PREFIX_MOBILE = '+41 '

# Format input field value as currency value with thousands separator
_formatCurrencyInputField = (input) ->
  val = $(input).val()
  formattedValue = ''

  if val && val.length > 0
    parsedValue = $CAM.parseCurrency(val)
    formattedValue = $CAM.formatCurrency parsedValue, currency:'', prefix: '', suffix: '', shorten: false

  $(input).val formattedValue

# Format input field value as phone number +41 00 000 00 00
_formatMobileNumberInputField = (input) ->
  formatted = $CAM.formatPhoneNumber $(input).val()
  formatted = PREFIX_MOBILE if !formatted || formatted.length == 0
  $(input).val formatted

# Format input field value as iban number XX00 0000 0000 0000 0000 0
_formatIbanInputField = (input) ->
  $(input).val $CAM.formatIban $(input).val()

# Format input field value as ch-uid CHE-000.000.000
_formatChUid = (input) ->
  $(input).val $CAM.formatChUid $(input).val()

# Format input field value as credit-card 0000-0000-0000-0000
_formatCreditCard = (input) ->
  options = 
    allowAsterisk: $(input).attr('data-format-allow-asterisk') == 'true'
  $(input).val $CAM.formatCreditCard $(input).val(), options

formatInputFields = ->
  # Make sure input fields are of type text if they are tagged for currency or iban formatting
  $ 'input[data-format="currency"], input[data-format="mobile-number"],
    input[data-format="iban"], input[data-format="ch-uid"], input[data-format="credit-card"]'
    .attr 'type', 'text'

  # Add pattern attribute to force mobile devices to open numpad on currency fields
  $ 'input[data-format="currency"]'
    .attr 'pattern', "[\\d']*"

  # Format all input fields defined as currency
  $ 'input[data-format="currency"]'
    .each ->
      _formatCurrencyInputField this

  # Format all input fields defined as mobile number
  $ 'input[data-format="mobile-number"]'
    .each ->
      _formatMobileNumberInputField this

  # Format all input fields defined as iban number
  $ 'input[data-format="iban"]'
    .each ->
      _formatIbanInputField this

  # Format all input fields defined as ch-uid number
  $ 'input[data-format="ch-uid"]'
    .each ->
      _formatChUid this

  # Format all input fields defined as credit-card number
  $ 'input[data-format="credit-card"]'
    .each ->
      _formatCreditCard this

$(document).ready(formatInputFields)

$(document).on 'change', 'input[data-format="currency"]', ->
  _formatCurrencyInputField this

$(document).on 'change', 'input[data-format="mobile-number"]', ->
  _formatMobileNumberInputField this

$(document).on 'change', 'input[data-format="iban"]', ->
  _formatIbanInputField this

$(document).on 'change', 'input[data-format="ch-uid"]', ->
  _formatChUid this

$(document).on 'change input', 'input[data-format="credit-card"]', ->
  _formatCreditCard this
